import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=5972e52e&scoped=true"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"
import style0 from "./Modify.vue?vue&type=style&index=0&id=5972e52e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5972e52e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5972e52e')) {
      api.createRecord('5972e52e', component.options)
    } else {
      api.reload('5972e52e', component.options)
    }
    module.hot.accept("./Modify.vue?vue&type=template&id=5972e52e&scoped=true", function () {
      api.rerender('5972e52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/org/Modify.vue"
export default component.exports